










































































import { Component, Vue, Watch } from "vue-property-decorator";
import { WorkerDetailsModule } from "@/store/modules/workerDetails";
import PositionDto from "@/models/Positions/PositionDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import WorkerPositionDto from "@/models/WorkerPositions/WorkerPositionDto";
import CreateWorkerPositionRequest from "@/models/WorkerPositions/CreateWorkerPositionRequest";
import WorkerPositionStatus from '@/models/WorkerPositions/WorkerPositionStatus';
import WorkType from "@/models/Shared/WorkType";
import ListUtils from "@/lib/listUtils";

@Component({
  name: "WorkerPositionCreate",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  position: PositionDto = new PositionDto();
  isVerified = false;
  payRate = 0;
  workTypes: WorkType[] = [ WorkType.Temp, WorkType.Perm ];
  isTemp = true;
  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.position = new PositionDto();
      this.isVerified = false;
      this.payRate = 0;
    }
  }

 @Watch('workTypes')
  async onWorkTypesChanged(val: WorkType[], oldVal: WorkType[]) {
    this.isTemp = val.includes(WorkType.Temp);
  }

  get positions() {
    return WorkerDetailsModule.agencyAttributes.positions;
  }

  get workTypeOptions() {
    return ListUtils.workTypes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateWorkerPositionRequest();
    request.positionId = this.position.id;
    if (this.isVerified){
        request.status = WorkerPositionStatus.Verified;
    } else {
        request.status = WorkerPositionStatus.Pending;
    }
    request.payRate = this.payRate;
    request.workTypes = this.workTypes;
    request.source = 1; // Manual
    await WorkerDetailsModule.createPosition(request);
    this.dialog = false;
  }
}
